import * as z from 'zod';

export const modeSchema = z.enum(['free', 'guided']);

export const walkthroughSchema = z
  .object({
    status: z.enum(['in_progress', 'completed']).default('in_progress'),
    currentStep: z.number().default(1),
    mode: modeSchema,
    sourceImage: z.string(),
    fileName: z.string(),
    prompt: z.string(),
    count: z.number().default(1),
    answers: z.record(z.string(), z.union([z.string(), z.array(z.string())])),
    businessNumber: z.string(),
  })
  .partial({
    mode: true,
    sourceImage: true,
    fileName: true,
    prompt: true,
    answers: true,
    businessNumber: true,
  });

export type Walkthrough = z.infer<typeof walkthroughSchema>;
